import React, {Component} from "react";
import AccountNumber from "Atoms/AccountNumber";
import Policies from "Molecules/Policies";
import Moment from "react-moment";
import Currency from "react-currency-formatter";
import PayOptions from "Molecules/PayOptions";
import Tag from "../../atoms/Tag/Tag";

export default class PayModalTemplate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            mobileOpen:false,
            mobileViewToggle: false
        }
    }

    openMobile =()=>{
      let mob1=document.getElementById("mobileOne");
      let mob2=document.getElementById("mobileTwo");
      
       mob1 && mob1.classList.add("show");
       mob2 && mob2.classList.add("show");

       this.setState({
           mobileOpen:true,
           mobileViewToggle: true

       })
    }

    mobileClose =()=>{
      let mob1=document.getElementById("mobileOne");
      let mob2=document.getElementById("mobileTwo");

      mob1 && mob1.classList.remove("show");
      mob2 && mob2.classList.remove("show");
      
        this.setState({
            mobileOpen:false,
            mobileViewToggle: true

        })
    }

    renderPaymentInfo = () => {
      if(!this.props.account.recurring_enabled && (this.props.account.minimum_due_amount <= 0)){
        return (
          <div className="due-breakdown-intro">
              <p></p>
          </div>
        )
      } else {
        if ((!this.props.account.past_due_amount > 0) && !this.props.account.recurring_enabled ) {
          return (
            <div className="due-breakdown-intro">
                <p>
                    Looks like your account has payment(s) due.<br/>
                    Please pay the balance due by the date shown.</p>
            </div>
          )
				} else if (this.props.account.recurring_enabled && (this.props.account.past_due_amount > 0)) {
					return (
						<div className="due-breakdown-intro has-error">
                <p>
                  There was a problem with processing your automatic payment.
						    </p>
								<p>
                   Please contact support to avoid a lapse in coverage at 1-888-978-5371 (Mon - Fri, 8 am - 8:30 pm ET).

					      </p>
              </div>

					)

					} else if (this.props.account.recurring_enabled && (this.props.account.past_due_amount <= 0)) {
					return (
						<div className="due-breakdown-intro">
                <p>
                  Automatic payments are enabled for this account.
						    </p>
								<p>
                  No action is required at this time.
					      </p>
              </div>

					)


        } else {
					if (this.props.account.past_due_amount > 0) {
						return (
              <div className="due-breakdown-intro has-error">
                <p>
                  Alert! Your account has payment(s) that are past due.
								</p>
								<p>
                  Keep your account active and pay the past-due balance now.
                </p>
              </div>
						)
          }
				}
      }
    }

    componentDidMount() {
      //check the initial rendering on mobile view.
      this.handleRenderMobileViewToggle();
      //place focus on the X to pay details modal
      
      const closePayDetailsModalBtn = document.querySelector(".pay-details-close");
      if(closePayDetailsModalBtn) closePayDetailsModalBtn.focus();
    
      // listen for return or escape keys to close out pay details modal
      document.body.onkeyup = (e) => {
        let closePayDetailsBtnIsActive = document.activeElement === closePayDetailsModalBtn;
        if (closePayDetailsBtnIsActive &&  (e.keyCode === 13 || e.keyCode === 27)) {
          this.props.close();
        }
      }



    }
   	componentWillReceiveProps(){
      //call when resizing
   		window.addEventListener("resize", this.handleRenderMobileViewToggle);
   	}

    componentWillUnmount = () => {
      window.removeEventListener("resize", this.handleRenderMobileViewToggle);
    }

    handleRenderMobileViewToggle = () => {
    	if (window.innerWidth < 760) {
    		this.setState({
    			mobileViewToggle: true
    		})
    	} else {
    		this.setState({
    			mobileViewToggle: false
    		})
    	}
    }


    handleClosePayModalTemplate = (e) => {
      if (e.keyCode === 13){
        this.props.close();
      }
    }

    checkCancelled = (policies) => {
      if(policies===undefined){
        return false;
      }
      const cancelledPolicies = policies.filter(el => {
        if(el.policy_status!==null && el.policy_status!==undefined){
          return el.policy_status.toLowerCase().includes("cancellation pending");
        }
        return false;
      });
      return cancelledPolicies.length>0;
    }
    classesFunc = (showModal) => {
      return showModal ? " open" : " close";
    }

    render() {
        let classes = this.classesFunc(this.props.showModal);
        const containsCancelledPolicies=this.checkCancelled(this.props.account.policies);
        return (
            <div className={"PayModalTemplate " + classes}>
                <div className="close" onKeyUp={this.handleClosePayModalTemplate} onClick={this.props.close}>
									<div role="button" className="dx-col pay-details-close" aria-label="close"
                    onClick={this.props.close} tabIndex="0" />
                </div>
                <div className="block ">
                    <div className="row account">
                        <div className="dx-col">
                            <div className="label"> Billing Account</div>
                            <div className="content">
                                {" "}{this.props.account ? (<div style={{"display": "flex","align-items": "center"}}>
                                      <AccountNumber accountNumber={this.props.account.account_number}/>
                                      {this.props.account.product_code==="RSCIA" && <Tag text={"RSCIA"}/>}
                                      {containsCancelledPolicies && <Tag text={"Cancellation Pending"}/>}
                                    </div>) : ("Loading")}{" "}
                                </div>
                        </div>
                    </div>
                    {!this.state.mobileOpen ?
                        <div className="mobile-toggle" onClick={this.openMobile} id="mobileOpen">
													<div className="mobile-open">+ More Details</div></div>:
                        <div className="mobile-toggle" onClick={this.mobileClose} id="mobileClose">
													<div className="mobile-close">- Less Details</div></div>}
                    <div className="mobile" id="mobileOne">
                        <div className="block ">
                          <Policies policies={this.props.account.policies} className="block" showAmount={this.state.mobileViewToggle}/>
                        </div>
                    </div>
                </div>


								<div className="payments-process-note">
									<div className="dx-col">Payments in process may not be reflected immediately.</div>
								</div>
                <div className="mobile" id="mobileTwo">
                    <div className="block em">
                        <div className="due-breakdown-area">
                            <div className="dx-col">
                                {this.renderPaymentInfo()}
                                <div className="due-breakdown">
                                  {this.props.account.minimum_due_amount > 0 &&
                                    <ul>
                                      {this.props.account.minimum_due_date ?
                                        <li> Minimum due by <Moment format="MMM DD, YYYY"date={this.props.account.current_due_date} /></li> :<li> Minimum Due </li>}
                                      <li><Currency quantity={this.props.account.minimum_due_amount} pattern="!#,##0.00" /></li>
                                    </ul>}

                                    {this.props.account.past_due_amount > 0 &&
                                      <div className="has-error-text">
                                        <ul>
                                          <li>(<Currency quantity={this.props.account.past_due_amount} pattern="!#,##0.00" /> past due included) </li>
                                          <li></li>
                                        </ul>
                                        </div>}
                                </div>
                                <div className="remaining-balance-note">
                                    <div className="dx-col">
                                        <p>{" "} You can also choose to pay the outstanding balance for your premium(s) in full.{" "}</p>
                                        <ul>
                                            <li>Full payment balance</li>
                                            <li><Currency quantity={this.props.account.pay_in_full_amount <= 0 ? "0.00" : this.props.account.pay_in_full_amount} pattern="!#,##0.00" /></li>
                                        </ul>
                                        {this.props.account.past_due_amount > 0 &&
                                          <div className="has-error-text" style={{color:"#E03C31"}}>
                                              <ul>
                                                  <li>(<Currency
                                                      quantity={this.props.account.past_due_amount}
                                                      pattern="!#,##0.00" /> past due included) </li>
                                                  <li></li>
                                              </ul>
                                            </div>}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="payOptions">
                    <div className="select-option-head">
                      <ul><li>Select Option</li></ul>
                    </div>
                    <div className="list">
                      <PayOptions props={this.props} index={100}/>
                    </div>
                    <div className="payOptions-button-area">
                        <button className="primary" onClick={this.props.close}>Done</button>
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./src/components/atomic/templates/PayModalTemplate/PayModalTemplate.js